module.exports = __webpack_public_path__ + "media/icons/envelope32-cab763f7.png";